var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModalEditar", {
        attrs: {
          titulo: "Editar Proveedor de GPS",
          form: Object.values(_vm.pasos).find(function(x) {
            return x.step === _vm.pasoActivoIndex
          }).formState,
          inactivable: _vm.modificable,
          estadoEntidad: _vm.estadoEntidad,
          pasos: _vm.pasos,
          inactivoSinAsociacion: _vm.inactivoSinAsociacion,
          pasoActivoIndex: _vm.pasoActivoIndex,
          nombreEntidad: _vm.lstProveedor.data
            ? _vm.lstProveedor.data.nombre
            : "",
          entidad: "Proveedor de GPS"
        },
        on: {
          cerrar: _vm.handleCerrar,
          guardar: _vm.handleGuardar,
          inactivo: _vm.handleInactivo
        }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("ProveedorForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.informacionGeneral.step,
                expression: "pasoActivoIndex === pasos.informacionGeneral.step"
              }
            ],
            attrs: {
              proveedorSeleccionado: _vm.lstProveedor.data,
              nuncaEdit: true
            },
            on: { change: _vm.handleFormChange }
          }),
          _c("ClienteProveedorGrid", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pasoActivoIndex === _vm.pasos.asociarProveedor.step,
                expression: "pasoActivoIndex === pasos.asociarProveedor.step"
              }
            ],
            attrs: {
              proveedorSeleccionado: _vm.lstProveedor.data,
              esEditar: true,
              idProveedor: _vm.proveedorSeleccionado
                ? _vm.proveedorSeleccionado.id
                : 0
            },
            on: { change: _vm.handleClientesProveedoresChange }
          })
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }